<template>
  <div>
    <div class="preUser expand">
      <div class="preUser-left">
        <div class="content-login registerLogin">
          <b-link to="/" style="width: fit-content">
            <img class="logo" src="@/assets/img/logo-login.png" />
          </b-link>
          <b-form class="Login">
            <div class="body">
              <div class="header-title-between" :class="validBorderStep">
                <div>
                  <span>Teacher Application Form</span>
                  <h4 v-if="registerStep == 0">Personal Information</h4>
                  <h4 v-if="registerStep == 1">Professional Profile</h4>
                  <h4 v-if="registerStep == 2"></h4>
                </div>

                <!-- <div class="back-step mt-0"  @click="backStep">
                                <img class="svg" src="@/assets/icons/icon-arrow-left.svg">{{$t('planesYPrecios.regresar')}}
                            </div> -->
                <div class="steps" v-if="registerStep != 2">
                  <div
                    class="step"
                    :class="registerStep == 0 ? 'active' : 'off'"
                  >
                    <span>1</span>
                  </div>
                  <div class="step" :class="registerStep == 1 ? 'active' : ''">
                    <span>2</span>
                  </div>
                </div>
              </div>
              <!-- Step 1 -->
              <div v-if="registerStep == 0">
                <!-- Body -->
                <b-row class="account-data mb-4">
                  <b-col sm="12" xl="6" cols="12" class="col-6">
                    <!-- Name fields -->
                    <div class="d-flex">
                      <b-form-group
                        id="input-firstname-title"
                        style="margin-right: 12px; max-width: 140px"
                        label="Name"
                      >
                        <!-- <p class="bold">Name</p> -->
                        <b-form-input
                          v-bind:class="{
                            error: $v.formTeacher.firt_name.$error,
                          }"
                          v-model.trim="$v.formTeacher.firt_name.$model"
                          id="input-firstname"
                        ></b-form-input>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.formTeacher.firt_name)
                        }}</span>
                      </b-form-group>

                      <b-form-group id="input-lastname-title" label="Last Name">
                        <!-- <p class="bold">Last Name</p> -->
                        <b-form-input
                          :class="{ error: $v.formTeacher.last_name.$error }"
                          v-model.trim="$v.formTeacher.last_name.$model"
                          id="input-lastname"
                        ></b-form-input>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.formTeacher.last_name)
                        }}</span>
                      </b-form-group>
                    </div>

                    <!-- Birthdate picker -->
                    <b-form-group
                      id="input-fecha-nacimiento-title"
                      label="Birthdate"
                    >
                      <b-input-group class="datepicker-group">
                        <b-form-input
                          :class="{ error: $v.formTeacher.birth_date.$error }"
                          placeholder="Enter your Date of Birth"
                          v-model="$v.formTeacher.birth_date.$model"
                          :value="
                            $v.formTeacher.birth_date.$model == null
                              ? ''
                              : `${
                                  $v.formTeacher.birth_date.$model.split('-')[1]
                                }/${
                                  $v.formTeacher.birth_date.$model.split('-')[2]
                                }/${
                                  $v.formTeacher.birth_date.$model.split('-')[0]
                                }`
                          "
                        ></b-form-input>
                        <!-- :value ="$v.formTeacher.birth_date.$model.split('-').reverse().join('/')" -->

                        <b-input-group-append>
                          <b-form-datepicker
                            button-only
                            right
                            :max="max"
                            locale="en"
                            :date-format-options="{
                              year: 'numeric',
                              month: 'numeric',
                              day: 'numeric',
                            }"
                            @input="SetDateFormat"
                          ></b-form-datepicker>
                        </b-input-group-append>
                        <!--
                                                v-model ="$v.formTeacher.birth_date.$model"
                                                 @focusin.native="$v.formTeacher.birth_date.$touch()"
                                                @input="SetDateFormat"
                                             -->
                      </b-input-group>
                      <span class="error-input d-block">{{
                        validationMsgRegistro($v.formTeacher.birth_date)
                      }}</span>
                    </b-form-group>

                    <!-- Phone number -->
                    <div class="d-flex flex-column">
                      <b-form-group label="Telephone">
                        <div class="d-flex">
                          <b-form-input
                            type="tel"
                            id="input-telefono"
                            v-model="$v.formTeacher.phone.$model"
                          ></b-form-input>
                          <b-form-input
                            type="tel"
                            id="input-telefono"
                            v-model="$v.formTeacher.phone.$model"
                            :class="{ error: $v.formTeacher.phone.$error }"
                          ></b-form-input>
                        </div>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.formTeacher.phone)
                        }}</span>
                        <span
                          v-if="countryNotSupported"
                          class="error-input d-block"
                        >
                          We currently don't support registrations from this
                          country.
                        </span>
                      </b-form-group>
                    </div>
                  </b-col>

                  <!-- Email and Password -->
                  <b-col sm="12" xl="6" cols="12" class="col-6">
                    <!-- Email -->
                    <b-form-group id="input-email-title" label="Email">
                      <!-- <p class="bold">Email</p> -->
                      <b-form-input
                        id="input-email"
                        type="email"
                        :class="{ error: $v.formTeacher.email.$error }"
                        v-model="$v.formTeacher.email.$model"
                      ></b-form-input>
                      <span class="error-input d-block">{{
                        validationMsgRegistro($v.formTeacher.email)
                      }}</span>
                    </b-form-group>

                    <!-- Password -->
                    <div class="footerRegisterTeacher">
                      <b-form-group
                        id="input-password-title"
                        label="Password"
                        style="margin-right: 12px"
                      >
                        <!-- <p>Contraseña</p> -->
                        <b-icon
                          class="eye"
                          :icon="eyesPassword ? 'eye' : 'eye-slash'"
                          aria-hidden="true"
                          @click="eyesPassword = !eyesPassword"
                        ></b-icon>
                        <b-form-input
                          id="input-password"
                          v-model="$v.formTeacher.password.$model"
                          :class="{ error: $v.formTeacher.password.$error }"
                          :type="eyesPassword ? 'password' : 'text'"
                          :placeholder="
                            eyesPassword ? '*********' : 'Enter the password'
                          "
                          autocomplete="off"
                        ></b-form-input>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.formTeacher.password)
                        }}</span>
                      </b-form-group>
                      <b-form-group
                        id="input-confirmPassword-title"
                        class="mb-0"
                        label="Confirm Password"
                      >
                        <!-- <p>Confirmar contraseña</p> -->
                        <b-icon
                          class="eye"
                          :icon="eyesConfirmPassword ? 'eye' : 'eye-slash'"
                          aria-hidden="true"
                          @click="eyesConfirmPassword = !eyesConfirmPassword"
                        ></b-icon>
                        <b-form-input
                          id="input-confirm-password"
                          v-model="$v.formTeacher.confirm_password.$model"
                          :class="{
                            error: $v.formTeacher.confirm_password.$error,
                          }"
                          :type="eyesConfirmPassword ? 'password' : 'text'"
                          :placeholder="
                            eyesConfirmPassword
                              ? '*********'
                              : 'Confirmar contraseña'
                          "
                          autocomplete="off"
                        ></b-form-input>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.formTeacher.confirm_password)
                        }}</span>
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>

                <!-- Footer -->
                <div class="text-center pt-2">
                  <div
                    class="back-step mt-0"
                    @click="backStep"
                    style="margin-bottom: -30px"
                  >
                    <icon name="arrow-left" />
                    {{ $t("planesYPrecios.regresar") }}
                  </div>
                  <b-button
                    class="btn btn-primary"
                    style="width: 140px"
                    :disabled="$v.formTeacher.$invalid"
                    @click="nextRegisterStep"
                    >Continue</b-button
                  >
                </div>
              </div>

              <!-- Step 2 -->
              <div
                class="d-flex mb-4"
                v-if="registerStep == 1"
                :class="directionRegister"
              >
                <div
                  class="content-photo"
                  style="padding-top: 20px; width: 210px; max-width: 180px"
                >
                  <b-avatar
                    variant="info"
                    class="mb-3"
                    size="145px"
                    :src="urlPhoto"
                    style="background: #b7b8bd; margin-left: 13px"
                  ></b-avatar>
                  <input
                    type="file"
                    ref="file"
                    style="display: none"
                    accept="image/*"
                    @change="handleFile"
                  />
                  <b-button
                    class="btn btn-primary d-block m-auto"
                    @click="$refs.file.click()"
                  >
                    <icon name="cloud-file-2" />Upload photo
                  </b-button>
                  <!-- <b-avatar variant="success" icon="people-fill"></b-avatar> -->
                </div>
                <div class="w-100">
                  <b-row
                    class="account-data w-100 m-0"
                    style="flex-wrap: initial; flex: 1"
                  >
                    <b-col sm="12" xl="6" cols="12" class="ml-0 col-6">
                      <b-form-group id="input-fecha-nacimiento-title">
                        <p class="d-flex align-items-center bold">
                          Video Presentation<span
                            id="tooltip1"
                            class="ml-2 icon-info"
                          >
                            <icon name="info" />
                          </span>
                        </p>
                        <b-tooltip target="tooltip1" placement="bottom"
                          >A link to your YouTube video presentation goes here.
                          Please be professional and include information about
                          where you are from, your experience and your teaching
                          style. The duration should be about 2 minutes.
                        </b-tooltip>
                        <b-form-input
                          placeholder="E.g. www.youtube.com/video"
                          v-model="$v.formTeacher2.url_video.$model"
                          v-bind:class="{
                            error: $v.formTeacher2.url_video.$error,
                          }"
                        ></b-form-input>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.formTeacher2.url_video)
                        }}</span>
                      </b-form-group>
                      <b-form-group
                        id="input-address-title"
                        label="CV / Résumé"
                      >
                        <!-- <p class="bold">CV / Résumé</p> -->
                        <VueFileAgent
                          ref="vueFileAgentCv"
                          :multiple="true"
                          :deletable="true"
                          :meta="true"
                          :accept="'.pdf'"
                          :maxSize="'10MB'"
                          :maxFiles="1"
                          :helpText="'Arrastra y suelta aquí los archivos'"
                          :theme="'list'"
                          @select="filesSelectedCV($event)"
                          @beforedelete="onBeforeDeleteCV($event)"
                          @delete="fileDeletedCV($event)"
                          v-model="formTeacher2.fileCV"
                        >
                          <template v-slot:after-inner>
                            <p
                              style="line-height: 1.3; margin-bottom: 4px"
                              :class="
                                fileRecordsForUploadCV.length >= 1 ? 'mt-3' : ''
                              "
                            >
                              Drag and drop files here or
                            </p>
                            <b-button class="btn btn-primary">
                              Browse
                            </b-button>
                          </template>
                          <template v-slot:after-outer>
                            <p class="footer-file-agent">
                              {{ fileRecordsForUploadCV.length }} / 1
                            </p>
                          </template>
                        </VueFileAgent>
                      </b-form-group>
                      <b-form-group id="input-address-title" label="Degrees">
                        <!-- <p class="bold">Degrees</p> -->
                        <VueFileAgent
                          ref="vueFileAgentDegrees"
                          :multiple="true"
                          :deletable="true"
                          :meta="true"
                          :accept="'.pdf,.jpg,.png'"
                          :maxSize="'10MB'"
                          :maxFiles="5"
                          :helpText="'Arrastra y suelta aquí los archivos'"
                          :theme="'list'"
                          @select="filesSelectedDegrees($event)"
                          @beforedelete="onBeforeDeleteDegrees($event)"
                          @delete="fileDeletedDegrees($event)"
                          v-model="formTeacher2.filesDegrees"
                        >
                          <template v-slot:after-inner>
                            <p
                              style="line-height: 1.3; margin-bottom: 4px"
                              :class="
                                fileRecordsForUploadDegrees.length >= 1
                                  ? 'mt-3'
                                  : ''
                              "
                            >
                              Drag and drop files here or
                            </p>
                            <b-button class="btn btn-primary">
                              Browse
                            </b-button>
                          </template>
                          <template v-slot:after-outer>
                            <p class="footer-file-agent">
                              {{ fileRecordsForUploadDegrees.length }} / 5
                            </p>
                          </template>
                        </VueFileAgent>
                      </b-form-group>
                      <b-form-group
                        id="input-address-title"
                        class="mb-0"
                        label="Certificates"
                      >
                        <!-- <p class="bold">Certificates</p> -->
                        <VueFileAgent
                          ref="vueFileAgentCerti"
                          :multiple="true"
                          :deletable="true"
                          :meta="true"
                          :accept="'.pdf,.jpg,.png'"
                          :maxSize="'10MB'"
                          :maxFiles="5"
                          :helpText="'Arrastra y suelta aquí los archivos'"
                          :theme="'list'"
                          @select="filesSelectedCerti($event)"
                          @beforedelete="onBeforeDeleteCerti($event)"
                          @delete="fileDeletedCerti($event)"
                          v-model="formTeacher2.filesCertificates"
                        >
                          <template v-slot:after-inner>
                            <p
                              style="line-height: 1.3; margin-bottom: 4px"
                              :class="
                                fileRecordsForUploadCerti.length >= 1
                                  ? 'mt-3'
                                  : ''
                              "
                            >
                              Drag and drop files here or
                            </p>
                            <b-button class="btn btn-primary">
                              Browse
                            </b-button>
                          </template>
                          <template v-slot:after-outer>
                            <p class="footer-file-agent">
                              {{ fileRecordsForUploadCerti.length }} / 5
                            </p>
                          </template>
                        </VueFileAgent>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" xl="6" cols="12" class="pr-0">
                      <b-form-group
                        id="input-fecha-nacimiento-title"
                        label="Languages Spoken"
                      >
                        <!-- <p class="d-flex align-items-center bold">Languages Spoken</p> -->
                        <b-form-input
                          v-model="$v.formTeacher2.languaje_description.$model"
                          v-bind:class="{
                            error: $v.formTeacher2.languaje_description.$error,
                          }"
                          required
                        ></b-form-input>
                        <span class="error-input d-block">{{
                          validationMsgRegistro(
                            $v.formTeacher2.languaje_description
                          )
                        }}</span>
                      </b-form-group>
                      <b-form-group
                        class="check-row mb-4"
                        label="Specialities"
                        id="specialities-check-box"
                      >
                        <!-- <p class="bold">Specialities</p> -->
                        <!-- {{optionsSpecialities}} -->
                        <b-tooltip target="tooltip2" placement="bottom"
                          >texto</b-tooltip
                        >
                        <b-form-checkbox-group
                          v-model="$v.formTeacher2.list_subject_level_id.$model"
                          :options="optionsSpecialities"
                          name="flavour-1a"
                          v-bind:class="{
                            error: $v.formTeacher2.list_subject_level_id.$error,
                          }"
                        ></b-form-checkbox-group>
                        <span class="error-input d-block">{{
                          validationMsgRegistro(
                            $v.formTeacher2.list_subject_level_id
                          )
                        }}</span>
                      </b-form-group>
                      <b-form-group id="specialities-check" class="mb-4">
                        <p class="bold">
                          Age Groups
                          <span id="tooltip2" class="ml-2 icon-info">
                            <icon name="info" />
                          </span>
                        </p>
                        <b-tooltip target="tooltip2" placement="bottom"
                          >Please select the age groups you can teach. The more
                          options you select, the more teaching opportunities
                          you will get. o</b-tooltip
                        >
                        <b-form-checkbox-group
                          v-model="$v.formTeacher2.list_segment_id.$model"
                          :options="optionsAge"
                          name="flavour-1a"
                          v-bind:class="{
                            error: $v.formTeacher2.list_segment_id.$error,
                          }"
                        ></b-form-checkbox-group>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.formTeacher2.list_segment_id)
                        }}</span>
                      </b-form-group>
                      <b-form-group
                        id="input-fecha-nacimiento-title"
                        class="mb-0"
                      >
                        <p class="d-flex align-items-center bold">
                          Methodology<span id="tooltip3" class="ml-2 icon-info">
                            <icon name="info" />
                          </span>
                        </p>
                        <b-tooltip target="tooltip3" placement="bottom"
                          >Please describe your teaching style using at least 40
                          words.
                        </b-tooltip>
                        <b-form-textarea
                          v-model="$v.formTeacher2.methodology.$model"
                          v-bind:class="{
                            error: $v.formTeacher2.methodology.$error,
                          }"
                          id="textarea-no-resize"
                          rows="6"
                          no-resize
                          placeholder="Please use at least 40 words."
                        ></b-form-textarea>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.formTeacher2.methodology)
                        }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!--   :disabled="disabledForm" -->
                  <b-form-group class="mt-4 text-center">
                    <b-form-checkbox
                      value="true"
                      v-model="$v.formTeacher2.flagAcepted.$model"
                      v-bind:class="{
                        error: $v.formTeacher2.flagAcepted.$error,
                      }"
                    >
                      <p class="text-left mb-0">
                        I have read and agree to the
                        <a
                          :href="pdf.PDF_TERMS"
                          target="_blank"
                          class="link blue"
                          style="font-size: 13px"
                          >Terms of Service</a
                        >,
                        <b-link
                          class="link blue"
                          :href="pdf.PDF_POLICY"
                          target="_blank"
                          style="font-size: 13px"
                          >Privacy Policy</b-link
                        >, and
                        <b-link
                          class="link blue"
                          :href="pdf.PDF_TEACHER_POLICY"
                          target="_blank"
                          style="font-size: 13px"
                          >Teacher’s Code of Conduct</b-link
                        >.
                      </p>
                    </b-form-checkbox>
                    <span class="error-input d-block">{{
                      validationMsgRegistro($v.formTeacher2.flagAcepted)
                    }}</span>
                  </b-form-group>
                  <div class="mt-4 text-center">
                    <b-button
                      class="btn btn btn-primary"
                      style="width: 120px"
                      :class="{ loading: isLoading }"
                      :disabled="disabledForm"
                      @click="registerTeacher"
                    >
                      Apply
                    </b-button>
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-center align-items-end pt-2"
                style="margin-bottom: 115px"
                v-if="registerStep == 2"
              >
                <img src="@/assets/img/requestSent.png" class="mr-5" />
                <div class="text-center" style="width: 400px">
                  <h6 class="bold mb-4" style="font-size: 22px">
                    We have received your information!
                  </h6>
                  <p style="font-size: 22px; line-height: 1.2">
                    We will contact you by email within the next five days.
                  </p>
                  <b-link
                    class="btn btn-primary mt-1 justify-content-center"
                    style="width: 133px"
                    to="/teacher/login"
                  >
                    Close
                  </b-link>
                </div>
              </div>
            </div>
          </b-form>
        </div>
      </div>
      <div class="preUser-right">
        <img src="@/assets/img/login-background3.jpg" class="no_mb" />
        <p>
          Propiedad de English Advance SAC, 2021. <br class="no_desktop" />
          Todos los Derechos Reservados.
        </p>
      </div>
      <b-toast
        id="toast-register-check"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
      >
        <img
          src="@/assets/img/ico-check.png"
          style="margin-right: 10px; margin-top: -2px"
        />
        {{ messageRegisterTeacher }}
      </b-toast>
      <b-toast
        id="toast-register-error"
        variant="none"
        no-close-button
        toaster="b-toaster-top-center"
      >
        <img
          src="@/assets/img/ico-equis.png"
          style="margin-right: 10px; margin-top: -2px"
        />
        {{ messageRegisterTeacher }}
      </b-toast>
    </div>
  </div>
</template>
<script>
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import Vue from "vue";
import VueFileAgent from "vue-file-agent";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import { validationMessage } from "vuelidate-messages";
import {
  required,
  email,
  sameAs,
  numeric,
  maxLength,
} from "vuelidate/lib/validators";
import { getTimeZoneUser, getTimeZoneNameUser } from "@/assets/js/util.js";
// Map intl-tel-input country names → API country names when they differ.
const COUNTRY_NAME_OVERRIDES = {
  "North Macedonia": "Macedonia",
};
import axios from "axios";
import { PDF } from "@/assets/js/appConstants";
import cursosJsonEN from "@/locales/material/cursos-en.json";
import examenesJsonEN from "@/locales/material/examenes-en.json";
import { countWords } from "@/assets/js/custom-validations.js";

Vue.use(VueFileAgent);
const formRegisterMessages = {
  required: function () {
    return this.$t("validations.formRegisterMessages.required-1");
  },
  email: function () {
    // return this.$t('validations.formRegisterMessages.email')
    return "Please use a valid email ";
  },
  flagEmailEnUso: function () {
    return this.$t("validations.formRegisterMessages.flagEmailEnUso");
  },
  strongPassword: function () {
    return this.$t("validations.formRegisterMessages.strongPassword");
  },
  noWhitespacesPassword: function () {
    return this.$t("validations.formRegisterMessages.noWhitespacesPassword");
  },
  maxLengthPassword: function ({ $params }) {
    return this.$t("validations.formRegisterMessages.maxLengthPassword", {
      nro: $params.maxLengthPassword.max,
    });
  },
  sameAsPassword: function () {
    return this.$t("validations.formRegisterMessages.sameAsPassword");
  },
  minLength: function ({ $params }) {
    return this.$t("validations.formRegisterMessages.minLength", {
      nro: $params.minLength.min,
    });
  },
  maxLength: function ({ $params }) {
    return this.$t("validations.formRegisterMessages.maxLength", {
      nro: $params.maxLength.max,
    });
  },
  alphaWithSpaces: function () {
    // return this.$t('validations.formRegisterMessages.alphaWithSpaces')
    return "Please use letters only";
  },
  numeric: function () {
    // return this.$t('validations.formRegisterMessages.numeric')
    return "Please use digits only";
  },
  isValidDate: function () {
    return "You must enter a valid date";
    //return this.$t('validations.formRegisterMessages.numeric') GH => Mover al Json
  },
  requiredIfYoutube: () => "Please use a valid YouTube link",
  requiredTyC: () => "You must accept the Terms and Conditions",
  countWords: () => "Please use at least 40 words.",
};
export default {
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    return {
      messageRegisterTeacher: "",
      isLoading: false,
      urlPhoto: null,
      optionsCountry: [],
      iti: null,
      countryNotSupported: false,
      eyesConfirmPassword: true,
      eyesPassword: true,
      pdf: PDF,
      formTeacher: {
        firt_name: null,
        last_name: null,
        email: null,
        password: null,
        // birth_date :  this.$moment().format("DD/MM/YYYY"),
        birth_date: null,
        confirm_password: null,
        phone: null,
        country_id: null,
        county_origin_id: null,
        city: null,
        time_zone_int: null,
        time_zone_name: null,
      },
      max: maxDate,
      formTeacher2: {
        photo: null,
        fileCV: [],
        filesDegrees: [],
        filesCertificates: [],
        methodology: null,
        languaje_description: null,
        url_video: null,
        list_segment_id: [],
        list_subject_level_id: [],
        flagAcepted: false,
      },
      registerStep: 0,
      optionsSpecialities: [],
      optionsAge: [],
      flagEmailEnUso: false,
      fileRecordsForUploadCV: [],
      fileRecordsForUploadDegrees: [],
      fileRecordsForUploadCerti: [],

      uploadUrl: "https://www.mocky.io/v2/5d4fb20b3000005c111099e3",
      uploadHeaders: { "X-Test-Header": "vue-file-agent" },
    };
  },
  components: {},
  validations: {
    formTeacher: {
      firt_name: {
        required,
      },
      last_name: {
        required,
      },
      birth_date: {
        required,
        isValidDate(value) {
          let date = this.$moment(value, "MM/DD/YYYY");
          return date.isValid() && /^(\d{2}\/\d{2}\/\d{4})$/g.test(value);
        },
      },
      email: {
        required,
        email,
        flagEmailEnUso(value) {
          if (value === "" || !this.$v.formTeacher.email) return true;

          return new Promise((resolve, reject) => {
            return baseInstanceAxios
              .get(
                `${this.apiURL}/resources/PersonsStudents/ExistsEmailByStudents?Email=${value}&Id=0&FlagStudent=false`
              )
              .then((response) => {
                resolve(!response.data.return);
              })
              .catch((error) => {
                reject(error);
              });
          });
        },
      },
      phone: {
        required,
        numeric,
      },
      password: {
        required,
        maxLengthPassword: maxLength(20),
        strongPassword(password) {
          return (
            /[a-z]/.test(password) && // condición minúscula (a-z)
            /[A-Z]/.test(password) && // condición mayúscula  (A-Z)
            /[0-9]/.test(password) && // condición número (0-9)
            /\W|_/.test(password) && // condición símbolo
            password.length >= 6
          );
        },
        noWhitespacesPassword(password) {
          return !/["/ +/"]/.test(password); // condición no espacios en blanco
        },
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs("password"),
      },
      country_id: {
        required,
      },
      county_origin_id: {
        required,
      },
    },
    formTeacher2: {
      photo: {
        required,
      },
      url_video: {
        required,
        requiredIfYoutube(url) {
          if (url != null) {
            let p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
            let matches = url.match(p);
            if (matches) {
              return true;
            }
            return false;
          }

          return false;
        },
      },
      languaje_description: {
        required,
      },
      methodology: {
        required,
        countWords,
      },
      list_segment_id: {
        required,
      },
      list_subject_level_id: {
        //required
      },
      flagAcepted: {
        requiredTyC(value) {
          return value;
        },
      },
    },

    validationGroup: ["formTeacher", "formTeacher2"],
  },
  created() {
    this.getListCountry();
    this.getListSubjectAndSegment();
  },
  mounted() {
    const input = document.querySelector("#input-telefono");
    this.iti = intlTelInput(input, {
      preferredCountries: ["PE", "US"],
      separateDialCode: true,
    });
    input.addEventListener("countrychange", this.onCountryChange);
  },
  computed: {
    directionRegister() {
      return window.innerWidth < 992 ? "flex-column" : "";
    },
    disabledForm() {
      return (
        this.$v.formTeacher2.$invalid || this.fileRecordsForUploadCV.length == 0
      ); //|| this.fileRecordsForUploadDegrees.length == 0 || this.fileRecordsForUploadCerti.length == 0;
    },
    validBorderStep() {
      return this.registerStep == 2 ? "border-0" : "";
    },
    // orderOptionsSpecialities(){
    //     this.optionsSpecialities
    // }
  },
  methods: {
    goLogin() {
      // this.$router.push({path:'/teacher/login'})
      //  backStep(){
      // this.$router.go(-1)
      // },
      window.location.href = "/teacher/login";
    },
    syncCountryId() {
      if (!this.iti || !this.optionsCountry.length) return;
      const selectedCountryData = this.iti.getSelectedCountryData();
      const selectedIso = (selectedCountryData.iso2 || "").toUpperCase();
      const selectedName = selectedCountryData.name;
      if (!selectedIso && !selectedName) return;

      // Primary match: ISO country code (language-independent, robust).
      let found = selectedIso
        ? this.optionsCountry.find(
            (c) => (c.isoCode || "").toUpperCase() === selectedIso
          )
        : null;

      // Fallback for any list entry missing an ISO code: normalized name match.
      if (!found && selectedName) {
        const normalize = (s) =>
          s
            .replace(/\s*\(.*$/, "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .trim();
        const normalized = normalize(
          COUNTRY_NAME_OVERRIDES[selectedName] || selectedName
        );
        found = this.optionsCountry.find(
          (c) => normalize(c.descripcion) === normalized
        );
      }

      this.formTeacher.country_id = found ? found.id : null;
      this.formTeacher.county_origin_id = found ? found.id : null;
      this.countryNotSupported = !found;
    },
    onCountryChange() {
      this.syncCountryId();
    },
    validationMsgRegistro: validationMessage(formRegisterMessages),
    SetDateFormat: function (value) {
      let dateFormat = this.$moment(value, "YYYY-MM-DD").format("MM/DD/YYYY");
      this.formTeacher.birth_date = dateFormat;
    },
    registerTeacher() {
      this.isLoading = true;

      let dataPost = this.formTeacher;
      let dateMomentObject = this.$moment(dataPost.birth_date, "MM/DD/YYYY");
      dataPost.birthDate = dateMomentObject.toDate();
      dataPost.timeZoneInt = getTimeZoneUser();
      dataPost.timeZoneName = getTimeZoneNameUser();
      dataPost.userCreated = dataPost.email;

      let dataPost1 = this.formTeacher2;

      let listSegmentIds = dataPost1.list_segment_id;
      let listSubject = [];
      listSubject = dataPost1.list_subject_level_id.map((element) => ({
        SubjectProgramId: parseInt(element.split("-")[0]),
        FlagProgram: element.split("-")[1] == "true" ? true : false,
      }));

      //console.log("dataPost.birthDate: ",dataPost.birthDate)
      const model = Object.freeze({
        FirstName: dataPost.firt_name,
        LastName: dataPost.last_name,
        Email: dataPost.email,
        Password: dataPost.password,
        Extension_Phone: this.iti.selectedCountryData.dialCode,
        PhoneNumber: dataPost.phone,
        CountryId: dataPost.country_id,
        CountryOriginId: dataPost.county_origin_id,
        City: dataPost.city,
        BirthDate: dataPost.birthDate,
        TimeZoneInt: dataPost.timeZoneInt,
        TimeZoneName: dataPost.timeZoneName,
        UserCreated: dataPost.userCreated,
        Methodology: dataPost1.methodology,
        CandidatesLanguageDescription: dataPost1.languaje_description,
        ListSegmentIds: listSegmentIds,
        ListSubjectLevelIds: listSubject,
        UrlVideo: dataPost1.url_video,
      });

      const formData = new FormData();
      formData.append("FilesPhoto", dataPost1.photo);
      formData.append(
        "FileCV",
        dataPost1.fileCV.length > 0 ? dataPost1.fileCV[0].file : null
      );

      dataPost1.filesDegrees.forEach((element) => {
        formData.append("ListFilesDegrees", element.file);
      });

      dataPost1.filesCertificates.forEach((element) => {
        formData.append("ListFilesCertificates", element.file);
      });

      formData.append("ModelStr", JSON.stringify(model));
      axios({
        method: "POST",
        url: `${this.apiURL}/resources/PersonsTeachers/SaveByTeachersByCandidate`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          if (response.data != null && response.data.return) {
            // this.messageRegisterTeacher = "Thank you very much for applying to English Advance. We will respond within 5 working days. ";
            // this.$bvToast.show("toast-register-check");
            this.limpiarForm();
            // setTimeout( ()=>{
            //         this.$router.go(-1)
            // }, 2000);
            this.registerStep = 2;
          } else {
            this.messageRegisterTeacher = this.$t("register.text");
            this.$bvToast.show("toast-register-error");
          }
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.messageRegisterTeacher = this.$t("register.text");
          this.$bvToast.show("toast-register-error");
          this.isLoading = false;
        });
    },
    limpiarForm() {
      this.formTeacher2 = {};
      this.formTeacher = {};
    },
    backStep() {
      this.$router.go(-1);
    },
    nextRegisterStep() {
      this.registerStep = 1;
    },
    getListCountry() {
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/Countries/ListCountries?flagLenguage=false`
        )
        .then((response) => {
          if (response.data != null && response.data.list) {
            this.optionsCountry = response.data.list;
            this.syncCountryId();
          }
        });
    },

    getListSubjectAndSegment() {
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/Subjects/ListSubjectsLevelAndSegmentsTeacher`
        )
        .then((response) => {
          this.optionsAge = response.data.entity.listSegments.map(
            (element) => ({
              text: element.descripcion,
              value: element.id,
            })
          );

          this.optionsSpecialities = response.data.entity.listSubjects.map(
            (element) => ({
              //text : element.subjectProgramName,subjectProgramId
              text: element.flagProgram
                ? cursosJsonEN.cursos.find(
                    (el) => el.id == element.subjectProgramId
                  ) != null
                  ? cursosJsonEN.cursos.find(
                      (el) => el.id == element.subjectProgramId
                    ).title
                  : element.subjectProgramName
                : examenesJsonEN.cursos.find(
                    (el) =>
                      el.title.toUpperCase() ==
                      element.subjectProgramName.toUpperCase()
                  ) != null
                ? examenesJsonEN.cursos.find(
                    (el) =>
                      el.title.toUpperCase() ==
                      element.subjectProgramName.toUpperCase()
                  ).acronym
                : element.subjectProgramName,
              value: `${element.subjectProgramId}-${element.flagProgram}`,
            })
          );
        });
    },
    handleFile(event) {
      for (var i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        this.urlPhoto = URL.createObjectURL(file);
        this.formTeacher2.photo = file;
        break;
      }
    },

    filesSelectedCV(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );

      this.fileRecordsForUploadCV = this.fileRecordsForUploadCV.concat(
        validFileRecords
      );
    },

    onBeforeDeleteCV(fileRecord) {
      var i = this.fileRecordsForUploadCV.indexOf(fileRecord);

      if (i !== -1) {
        this.fileRecordsForUploadCV.splice(i, 1);

        var k = this.formTeacher2.fileCV.indexOf(fileRecord);
        if (k !== -1) this.formTeacher2.fileCV.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgentCv.deleteFileRecord(fileRecord);
        }
      }
    },

    fileDeletedCV(fileRecord) {
      var i = this.fileRecordsForUploadCV.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadCV.splice(i, 1);
      } else {
        this.deleteUploadedFileCV(fileRecord);
      }
    },
    deleteUploadedFileCV: function (fileRecord) {
      this.$refs.vueFileAgentCv.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      );
    },

    filesSelectedDegrees(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );

      this.fileRecordsForUploadDegrees = this.fileRecordsForUploadDegrees.concat(
        validFileRecords
      );
    },

    onBeforeDeleteDegrees(fileRecord) {
      var i = this.fileRecordsForUploadDegrees.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadDegrees.splice(i, 1);

        var k = this.formTeacher2.filesDegrees.indexOf(fileRecord);
        if (k !== -1) this.formTeacher2.filesDegrees.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgentDegrees.deleteFileRecord(fileRecord);
        }
      }
    },

    fileDeletedDegrees(fileRecord) {
      var i = this.fileRecordsForUploadDegrees.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadDegrees.splice(i, 1);
      } else {
        this.deleteUploadedFileCV(fileRecord);
      }
    },
    deleteUploadedFileDegrees: function (fileRecord) {
      this.$refs.vueFileAgentDegrees.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      );
    },

    filesSelectedCerti(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUploadCerti = this.fileRecordsForUploadCerti.concat(
        validFileRecords
      );
    },

    onBeforeDeleteCerti(fileRecord) {
      var i = this.fileRecordsForUploadCerti.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadCerti.splice(i, 1);

        var k = this.formTeacher2.filesCertificates.indexOf(fileRecord);
        if (k !== -1) this.formTeacher2.filesCertificates.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgentCerti.deleteFileRecord(fileRecord);
        }
      }
    },

    fileDeletedCerti(fileRecord) {
      var i = this.fileRecordsForUploadCerti.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadCerti.splice(i, 1);
      } else {
        this.deleteUploadedFileCV(fileRecord);
      }
    },
    deleteUploadedFileCerti: function (fileRecord) {
      this.$refs.vueFileAgentCerti.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      );
    },
  },
};
</script>

<style>
.iti__flag {
  background-image: url("/images/flags.png");
}
</style>
